// // src/components/homepage/Footer.jsx
// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FaYoutube,
//   FaGithub,
//   FaLinkedin,
//   FaDiscord,
//   FaRegCommentDots,
// } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-agBg py-24 mt-16">
//       <div className="container mx-auto px-4 text-center lg:text-left">
//         {/* First Row: (No Logo, skip) */}

//         {/* Second Row: Links and Social Icons */}
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8 py-4">
//           {/* Company Links */}
//           <div className="flex flex-col space-y-1">
//             <h3 className="text-sm text-agBlack font-medium mb-4">Company</h3>
//             <Link
//               to="/about"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               About Us
//             </Link>
//             <Link
//               to="/contact"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Contact
//             </Link>
//           </div>

//           {/* Legal and Policy */}
//           <div className="flex flex-col space-y-1">
//             <h3 className="text-sm text-agBlack font-medium mb-4">
//               Legal & Policy
//             </h3>
//             <Link
//               to="/privacy"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Privacy Policy
//             </Link>
//             <Link
//               to="/terms"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Terms of Use
//             </Link>
//             <Link
//               to="/refund"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Refund Policy
//             </Link>
//             <Link
//               to="/disclaimer"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Disclaimer
//             </Link>
//           </div>

//           {/* Quick Links */}
//           <div className="flex flex-col space-y-1">
//             <h3 className="text-sm text-agBlack font-medium mb-4">
//               Quick Links
//             </h3>
//             <Link
//               to="/shop"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Shop
//             </Link>
//             <Link
//               to="/vendor/register"
//               className="text-xs text-agLightGray font-light hover:underline"
//             >
//               Become a Vendor
//             </Link>
//           </div>

//           {/* Social Icons */}
//           <div className="flex justify-center space-x-4 text-agLightGray cursor-pointer">
//             <a
//               href="https://github.com"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaGithub size={20} />
//             </a>
//             <a
//               href="https://linkedin.com"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaLinkedin size={20} />
//             </a>
//             <a
//               href="https://discord.com"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaDiscord size={20} />
//             </a>
//             <a
//               href="https://www.tiktok.com"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaRegCommentDots size={20} />
//             </a>
//             <a
//               href="https://youtube.com"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaYoutube size={20} />
//             </a>
//           </div>
//         </div>

//         {/* Third Row: Disclaimer */}
//         <p className="text-xs text-agLightGray font-light text-center mb-8">
//           Disclaimer: Information provided on Agrolinka is for general
//           informational purposes only.{" "}
//           <Link
//             to="/disclaimer"
//             className="text-xs font-light text-agBlue underline"
//           >
//             Read More
//           </Link>
//         </p>

//         {/* Fourth Row: Copyright */}
//         <p className="text-xs text-agLightGray font-light text-center">
//           © {new Date().getFullYear()} Agrolinka. All rights reserved.
//         </p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// src/components/homepage/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa"; // ✅ Correct social icons
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-agBg py-24 mt-16">
      <div className="container mx-auto px-4 text-center lg:text-left">
        {/* Second Row: Links and Social Icons */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8 py-4">
          {/* Company Links */}
          <div className="flex flex-col space-y-1">
            <h3 className="text-sm text-agBlack font-medium mb-4">Company</h3>
            <Link
              to="/about"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              About Us
            </Link>
            <Link
              to="/contact"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Contact
            </Link>
          </div>

          {/* Legal and Policy */}
          <div className="flex flex-col space-y-1">
            <h3 className="text-sm text-agBlack font-medium mb-4">
              Legal & Policy
            </h3>
            <Link
              to="/privacy"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Terms of Use
            </Link>
            <Link
              to="/refund"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Refund Policy
            </Link>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col space-y-1">
            <h3 className="text-sm text-agBlack font-medium mb-4">
              Quick Links
            </h3>
            <Link
              to="/shop"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Shop
            </Link>
            <a
              href="https://vendor.agrolinka.com/signup/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-agLightGray font-light hover:underline"
            >
              Become a Vendor
            </a>
          </div>

          {/* Social Icons */}
          <div className="flex justify-center space-x-4 text-agLightGray cursor-pointer">
            <a
              href="https://www.facebook.com/agrolinka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={20} />
            </a>
            <a
              href="https://www.instagram.com/agrolinka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={20} />
            </a>
            <a
              href="https://x.com/agrolinka"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaXTwitter size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/agrolinka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin size={20} />
            </a>
          </div>
        </div>

        {/* Fourth Row: Copyright */}
        <p className="text-xs text-agLightGray font-light text-center">
          © {new Date().getFullYear()} Agrolinka. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
